import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import SupervisePageShell from "@/components/supervise/supervise-page-shell";
import type { SuperviseTab } from "@/lib/supervise/use-supervise-access";

const pathToSuperviseTab = (pathname: string): Exclude<SuperviseTab, "user"> | "user" | null => {
	if (pathname.includes("/supervise/user")) {
		return "user";
	}
	if (pathname.includes("/supervise/workinghours")) {
		return "workinghours";
	}
	if (pathname.includes("/supervise/rulebreaks")) {
		return "rulebreaks";
	}
	if (pathname.includes("/supervise/activity") || pathname.endsWith("/supervise") || pathname.endsWith("/supervise/")) {
		return "activity";
	}
	return null;
};

const shellTabFromPath = (pathname: string): Exclude<SuperviseTab, "user"> | null => {
	const tab = pathToSuperviseTab(pathname);
	if (!tab || tab === "user") {
		return null;
	}
	return tab;
};

const SuperviseLayout = (): JSX.Element => {
	const tab = useRouterState({
		select: (state) =>
			shellTabFromPath(state.location.pathname) ??
			(state.resolvedLocation ? shellTabFromPath(state.resolvedLocation.pathname) : null),
	});
	if (!tab) {
		return <Outlet />;
	}
	return (
		<SupervisePageShell tab={tab}>
			<Outlet />
		</SupervisePageShell>
	);
};

export const Route = createFileRoute("/_app/supervise")({
	component: SuperviseLayout,
});
